import { useRequiredContext } from "@redotech/react-util/context";
import { getCarrierTrackingUrl } from "@redotech/redo-model/order-tracking/carriers/carrier-resolver";
import type { TrackingPageShipment } from "@redotech/redo-model/order-tracking/tracking-page-order-definition";
import { memo } from "react";
import { ExternalLink } from "../../../link";
import { Text } from "../../../text";
import { TrackingPageContext } from "../../context/tracking-page-context";
import { getLinkStyles } from "../shared/block-styles";

export const DeliveryEstimate = memo(function DeliveryEstimate({
  delivery,
  pastPreTransit,
  shipment,
}: {
  delivery: {
    isDelivered: boolean;
    date: Date | null | undefined;
    eddDistrusted: boolean;
  };
  pastPreTransit: boolean;
  shipment?: TrackingPageShipment;
}) {
  const { returnAppSettings, pageSettings } =
    useRequiredContext(TrackingPageContext);

  const linkStyles = getLinkStyles(pageSettings);

  const trackingUrl =
    getCarrierTrackingUrl(
      shipment?.carrier ?? undefined,
      shipment?.trackingCode ?? undefined,
    ) ?? shipment?.trackingUrl;

  const textProps = {
    fontSize: "lg" as const,
    fontWeight: "semibold" as const,
    style: {
      fontFamily: pageSettings?.typography.headerFontFamily,
      color: pageSettings?.typography.headerFontColor,
    },
    textColor: "secondary" as const,
  };

  if (delivery.isDelivered || !pastPreTransit) {
    return null;
  }

  if (returnAppSettings.storeUrl === "shopconzuri.myshopify.com") {
    return null;
  }

  if (!delivery.date) {
    return (
      <Text {...textProps}>
        {delivery.eddDistrusted ? "Unknown ETA" : "Awaiting ETA"}
      </Text>
    );
  }

  const label = <Text {...textProps}>Estimated Delivery</Text>;

  if (trackingUrl) {
    return (
      <ExternalLink showIcon={false} style={linkStyles} url={trackingUrl}>
        {label}
      </ExternalLink>
    );
  }

  return label;
});
